// SearchCandidates.jsx
import React, { useState } from "react";
import KeywordsComponent from "./KeywordsComponent";
import ExperienceComponent from "./ExperienceComponent";
import LocationComponent from "./LocationComponent";
import IndustryComponent from "./IndustryComponent";
import SalaryComponent from "./SalaryComponent";
import { SavedRecentSearch } from "./SavedRecentSearch";
import DepartmentRole from "./DepartmentRole";
import CompanyComponent from "./CompanyComponent";
import DiversityDetails from "./DiversityDetails";
import EducationComponent from "./EducationComponent";
import WorkDetails from "./WorkDetails";
import Navbar from "./Navbar";

function SearchCandidates() {
  const [keywords, setKeywords] = useState([]);
  const [currentKeyword, setCurrentKeyword] = useState("");

  const [company, setCompany] = useState([]);
  const [currentCompany, setCurrentCompany] = useState("");

  const [experience, setExperience] = useState({ min: 0, max: null });
  const [salary, setSalary] = useState({ min: null, max: null });
  const [excludeKeywords, setExcludeKeywords] = useState("");

  const handleAddKeyword = (e) => {
    if (e.key === "Enter" && currentKeyword.trim() !== "") {
      setKeywords([
        ...keywords,
        { text: currentKeyword.trim(), isStarred: false },
      ]);
      setCurrentKeyword("");
      e.preventDefault();
    }
  };

  const handleRemoveKeyword = (keywordText) => {
    setKeywords(keywords.filter((kw) => kw.text !== keywordText));
  };

  const toggleStar = (index) => {
    const newKeywords = [...keywords];
    newKeywords[index].isStarred = !newKeywords[index].isStarred;
    setKeywords(newKeywords);
  };

  const clearAllKeywords = () => setKeywords([]);

  const handleAddCompany = (e) => {
    if (e.key === "Enter" && currentCompany.trim() !== "") {
      setCompany([
        ...company,
        { text: currentCompany.trim(), isStarred: false },
      ]);
      setCurrentCompany("");
      e.preventDefault();
    }
  };

  const handleRemoveCompany = (companyText) => {
    setCompany(company.filter((cy) => cy.text !== companyText));
  };

  const companyToggleStar = (index) => {
    const newCompany = [...company];
    newCompany[index].isStarred = !newCompany[index].isStarred;
    setCompany(newCompany);
  };

  const clearAllCompany = () => setCompany([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      keywords,
      experience,
      salary,
    });
  };

  return (
   <div className="w-full flex-auto">
    <Navbar/>
    <div className="bg-gray-200 flex flex-col mt-2 md:flex-row justify-center p-auto">
      {/* Left Section for Form */}
      <form
        onSubmit={handleSubmit}
        className="w-full md:w-3/4 lg:w-1/2 ml-auto space-y-6"
      >
        {/* Active In dropdown and Search button */}
        <div className="flex items-center justify-between mt-4 mb-6">
          <div className="flex items-center ml-auto">
            <label htmlFor="activeIn" className="text-gray-700 font-bold mr-2">
              Active in -
            </label>
            <select
              id="activeIn"
              className="border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="1 day">1 day</option>
              <option value="1 week">1 week</option>
              <option value="1 month">1 month</option>
              <option value="3 months">3 months</option>
              <option value="6 months">6 months</option>
              <option value="1 year">1 year</option>
              <option value="5 years">5 years</option>
            </select>
          </div>

        </div>


        <div className="space-y-4">
          <KeywordsComponent
            keywords={keywords}
            currentKeyword={currentKeyword}
            handleAddKeyword={handleAddKeyword}
            handleRemoveKeyword={handleRemoveKeyword}
            toggleStar={toggleStar}
            clearAllKeywords={clearAllKeywords}
            setCurrentKeyword={setCurrentKeyword}
          />

          <ExperienceComponent
            experience={experience}
            setExperience={setExperience}
          />

          <LocationComponent
            excludeKeywords={excludeKeywords}
            setExcludeKeywords={setExcludeKeywords}

          />

          <SalaryComponent salary={salary} setSalary={setSalary} />

          <DepartmentRole />
          <IndustryComponent />

          <CompanyComponent
            company={company}
            currentCompany={currentCompany}
            handleAddCompany={handleAddCompany}
            handleRemoveCompany={handleRemoveCompany}
            companyToggleStar={companyToggleStar}
            clearAllCompany={clearAllCompany}
            setCurrentCompany={setCurrentCompany}
          />

          <EducationComponent />
          <DiversityDetails />
          <WorkDetails />
        </div>
      </form>

      <SavedRecentSearch />
    </div>
    </div>
  );
}

export default SearchCandidates;
